import React, { ReactElement, useMemo, useState } from "react";
import Select from "react-select";
import { Loading } from "../ui";
import { useUsers } from "../users/";
import { User } from "./User";

interface IProps {
	handleChange: (selectedUsers: any[], actionType: any) => any;
	value?: any;
	defaultValue?: any;
	isMulti?: boolean;
}

export const UserSelect = (props: IProps): ReactElement => {
	const [users, setUsers] = useState([]);

	const userContext = useUsers();

	useMemo(() => {
		const fetchUsers = async () => {
			const usersData = await userContext.fetchUsers!();
			setUsers(usersData);
		};

		fetchUsers();
	}, []);

	if (!users || !users.length) {
		return <Loading />;
	}

	const options = users.map((user: User) => {
		return {
			value: user.id,
			label: user.fullName,
		};
	});

	return (
		<Select
			{...props}
			options={options}
			isMulti={props.isMulti !== undefined ? props.isMulti : true}
			isClearable={false}
			onChange={(selectedUsers: any, actionType: any) => {
				props.handleChange(selectedUsers, actionType);
			}}
		/>
	);
};
